import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import { Config } from './store/wishlist/wishlistInterfaces';
import { store } from './store/store';
import App from './App';
import ThemeSelector from '@components/themes/ThemeSelector';

export const savedItemsWidget = {
  new: (config: Config) => {
    return {
      render: () => {
        ReactDOM.render(
          <Provider store={store}>
            <ThemeSelector brand={config.brand}>
              <App data={config} />
            </ThemeSelector>
          </Provider>,
          document.querySelector(config.selector)
        );
      },
    };
  },
};

if (process.env.NODE_ENV === 'development') {
  window.tealium_data2track = [];

  // configurator object
  const config: Config = {
    /* id of the dom element inside which the react component is rendered */
    selector: '#root',
    /* url of a lang file tu override from outside some labels */
    langUrl: '/data/langUrl_label.json',
    /* land of the site */
    lang: 'en',
    /* navigate componet with mocks */
    mockRequests: true,
    /* country of the site */
    country: 'US',
    /* brand of the site where the component is integrated: will be used to choose the applied style to the component. Accepted values: LC, TO */
    brand: 'TO',
    /* hostname to which the component will make calls for services, assets, etc  */
    hostname: 'https://uatstage.targetoptical.com',
    // hostname: 'https://uatstage.targetoptical.com',
    /* id of the store  */
    storeId: '12001',
    /* id of the catalog */
    catalogId: '12751',
    /* id language */
    langId: -1,
    /* enable disable find in store link (LC only) */
    findAndTryInStoreEnabled: true,
    /* external pages */
    pagesUrl: {
      warrantyUrl: 'https://uat.lenscrafters.com/lc-us/our-guarantee?section=protectionPlan',
      cartUrl: 'https://uatstage.targetoptical.com/cart',
      cartLearnMoreUrl: 'https://uatstage.targetoptical.com/read-mode',
    },
    /* paths to services endpoints */
    endpoints: {
      getSavedItem: '/wcs/resources/store/10851/catalog/17003/saveditems/@self',
      removeSavedItem: '/wcs/resources/store/10851/catalog/17003/saveditems/@self/byId/',
      updateSavedItemQuantityContact:
        '/wcs/resources/store/10851/catalog/17003/saveditems/@self/byId/',
      updateSavedItemWarranty:
        '/wcs/resources/store/{storeId}/catalog/{catalogId}/saveditems/@self/byId/{savedItemId}/warranty',
    },
    /* actions handled by WCS (e.g. add to bag) */
    actions: {
      /* add to cart functions */
      addToBagFrameLens: function (params) {
        // wcs handles the logic, returns promise for async operation
        return new Promise(resolve => {
          setTimeout(resolve, 1000);
        });
      },
      addToBagContacts: function (params) {
        // wcs handles the logic, returns promise for async operation
        return new Promise(resolve => {
          setTimeout(resolve, 1000);
        });
      },
      toggleFindAndTryInStore: function (params) {
        // for LC only - for frame only
        // wcs handles the logic, returns promise for async operation
        return new Promise(resolve => {
          setTimeout(resolve, 1000);
        });
      },
      updateSavedItemsCount: function () {
        // wcs handles the logic, returns promise for async operation
        return new Promise(resolve => {
          setTimeout(resolve, 1000);
        });
      },
    },
  };

  const myWidget = savedItemsWidget.new(config);
  myWidget.render();
}
